export function formatCurrency(amountX100: number): string {
  if (amountX100 === 0) {
    return "$0.00";
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amountX100 / 100);
}
